import { HTMLAttributeAnchorTarget } from 'react';

type Props = {
  uri: string;
  identificador: string | number;
  target?: HTMLAttributeAnchorTarget;
  forceRight?: boolean;
  onClick?: () => void;
};

const CustomLinkExternal = ({
  identificador,
  uri,
  target = '_blank',
  forceRight = false,
  onClick
}: Props) => {
  const onClickHandler = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <a
      target={target}
      rel="noopener noreferrer"
      href={uri}
      style={forceRight ? { marginLeft: 'auto' } : {}}
      onClick={onClickHandler}
    >
      {identificador}&nbsp;&nbsp;
      <i className="fas fa-external-link-alt blue-40" />
    </a>
  );
};

export { CustomLinkExternal };
